import { atomFamily, selectAtom } from "jotai/utils";
import { questionnaireReducerAtom } from "./questionnaireReducerAtom";

export const questionnaireVisibilityAtom = atomFamily((questionName: string) =>
  selectAtom(
    questionnaireReducerAtom,
    state => state.visibility?.[questionName],
  ),
);
